import React from 'react';
import dayjs from 'dayjs';
import CalendarWidget from 'components/FormFields/CalendarWidget';
import TimeZoneSelect from '../Calendar.TimeZoneSelect';

const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

const EventDate = ({
  start,
  end,
  datePreference,
  myTimeZone,
  projectTimeZone,
  displayTz,
  setStart,
  setEnd,
  setTimeZone,
}) => {
  const dateFormat = datePreference?.toUpperCase() ?? DEFAULT_DATE_FORMAT;

  return (
    <div className="event-card__date-picker">
      <CalendarWidget
        name="From"
        date={dayjs(start).format(dateFormat)}
        pickerDate={dayjs(start).format(dateFormat)}
        hasClear={false}
        required
        setDate={setStart}
        dateFormatLabel="YYYY-MM-DD"
        nNextYears={10}
        showNextYears
      />

      {end ? (
        <CalendarWidget
          name="To"
          date={dayjs(end).format(dateFormat)}
          pickerDate={dayjs(end).format(dateFormat)}
          hasClear={false}
          required
          setDate={setEnd}
          dateFormatLabel="YYYY-MM-DD"
          nNextYears={10}
          showNextYears
        />
      ) : null}
      {displayTz && (
        <TimeZoneSelect
          myTimeZone={myTimeZone}
          projectTimeZone={projectTimeZone}
          timeZone={displayTz}
          onTimeZoneChange={setTimeZone}
          displayMyTimezone
          displayProjectTimezone
          required
        />
      )}
    </div>
  );
};

export default EventDate;
